/* 
 	* 指令下发组件 
 	* 描述:A5C设置工作模式
 	* 创建时间：2017-07-11
 	* 创建人：baixx
*/
<template>
    <div>
		<form class="form-horizontal">
			<div class="form-group  pt10px">
			<label class="col-sm-3 control-label"><span class="red pr5px">*</span>选择模式</label>
			<div class="col-sm-9">
			    <span  class="pr10px">
			      <input type="radio" name="t" value="0" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">间隔模式</div></label>
			    </span>
			    <span  class="pr10px">
			      <input type="radio" name="t" value="1" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">时段闹钟模式</div></label>
			    </span>
			    <span >
			      <input type="radio" name="t" value="2" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">星期闹铃模式</div></label>
			    </span>
				</div>
			</div>
			<div class="form-group" v-if="timeMode==0">
			   	<label class="col-sm-3 control-label"><span class="red pr5px">*</span>唤醒间隔</label>
			   	<div class="col-sm-8">
			   		<span class="f_left pt5px">每</span>
					<div class="col-sm-5">
			   		<input type="text" class="form-control" v-model="min"/>
					</div>	
			   		<span class="f_left pt5px">分钟&nbsp;&nbsp;&nbsp;&nbsp;(1-999)</span>
			   	</div>
			</div>
			
			<div class="form-group" v-if="timeMode==1">
				<label class=" col-sm-3 control-label"> <span class="red pr5px">*</span> 每天指定唤醒时段（最多4个）</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" placeholder="HH:mm,HH:mm,HH:mm,HH:mm" v-model="durationStr"/>
				</div>
			</div>
			<div  v-if="timeMode==2">
				<div class="form-group">
					<label class="col-sm-3 control-label"><span class="red pr5px">*</span>星期</label>
			<div class="col-sm-9">
			    <span  class="pr15px">
				      <input type="checkbox" v-model="mon"/>
				      <label class="control-label"><div class="weight_n">周一</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="tue"/>
				      <label class="control-label"><div class="weight_n">周二</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="wed"/>
				      <label class="control-label"><div class="weight_n">周三</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="thu"/>
				      <label class="control-label"><div class="weight_n">周四</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="fri"/>
				      <label class="control-label"><div class="weight_n">周五</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sat"/>
				      <label class="control-label"><div class="weight_n">周六</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sun"/>
				      <label class="control-label"><div class="weight_n">周日</div></label>
				   </span></div>
				</div>
				<div class="form-group">
					<label class="control-label col-sm-3"><span class="red pr5px">*</span>唤醒时间</label>
					<div class="col-sm-8">
						<input type="text" class="form-control" placeholder="HH:mm" v-model="duration3"/>

					</div>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pr10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
	
		</form>
    </div>	
</template>
<script>
	export default {
		name: "InsA5CSetWorkMode",
		data() {
			return {
				timeMode :"0",         
				min:'', 
				durationStr:'',
				sat:0,
				fri:0,
				thu:0,
				wed:0,
				tue:0,
				mon:0,
				sun:0,
				duration3:'',
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			timeMode(val){
				this.alertMsg = ''
				if(val==0){
					this.min = ''
				}else if(val == 1){
					this.durationStr = ''
				}else if(val == 2){
					this.sat = 0
					this.fri = 0
					this.thu = 0
					this.wed = 0
					this.tue = 0
					this.mon = 0
					this.sun = 0
					this.duration3 = ''
				}
			},
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.timeMode = '0';
				this.alertMsg = ''
				this.min = ''
			},
			compareFunc(t1,t2){
				let h1 = t1.split(':')[0]
				let m1 = t1.split(':')[1]
				let h2 = t2.split(':')[0]
				let m2 = t2.split(":")[1]
			//	console.log(Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)))
				return Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)) >= 5
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				const that = this
				if(this.timeMode==0){
					let compare1 = Number(that.min) <= 999
					let compare2 = Number(that.min) >= 1
					if(String(that.min).indexOf(".")>-1){
						this.alertMsg = '唤醒间隔时间必须为整数'
						return
					}
					if(compare1 && compare2 && that.min){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒间隔填写不正确'
						return
					}
				}else if(this.timeMode == 1){
					let resStr = this.durationStr.replace(/\s*/g, "")  //去掉空格
					let durationStr = /^((?:(?:0|1)\d|2[0-3]):[0-5]\d\,){0,4}(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(resStr)
					if(durationStr){
						let arr = resStr.split(',');
						if(resStr.split(",").length>4){
							this.alertMsg = '唤醒时段最多4个'
							return
						}
						if(arr.length >= 2){
							for(let i = 0,l = arr.length; i < l - 1; i ++){
								let compare = this.compareFunc(arr[i],arr[i + 1])
								if(compare){
									this.alertMsg = ''
								}else{
									this.alertMsg = '请从小到大输入时段，且间隔不小于5分钟'
									return
								}
							}
						}
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时段填写不正确'
						return
					}
				}else if(this.timeMode==2){
					//mode4
					let duration3 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.duration3) 
					let r6 = this.sat || this.mon || this.tue || this.wed || this.thu || this.fri || this.sun
					if(duration3){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时间填写不正确'
						return
					}
					if(r6){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请选择星期'
						return
					}
				}else{
					return
				}
				let arr = [];
				let arrNew = '';
				switch (this.timeMode){
					case '0'://间隔模式：[唤醒间隔-分钟]
						arr = ['SETPRM','MODE','D',this.min]
						break;
					case '1'://时段闹钟
					 let durationStr = this.durationStr.replace(/:/g,'')
						arr = ['SETPRM','MODE','R',durationStr]//[唤醒时段1],[唤醒时段2],[唤醒时段3],[唤醒时段4]
						break;
					case '2'://星期闹钟（无论周几，选中为1，不选为0）：[周六],[周五],[周四],[周三],[周二],[周一],[周日],[唤醒时间]
					    let dur3 = this.duration3.replace(/:/g,'')
					    arrNew =(this.mon?'1':'0')+(this.tue?'2':'0')+ (this.wed?'3':'0')+(this.thu?'4':'0')+(this.fri?'5':'0')+(this.sat?'6':'0')+(this.sun?'7':'0')
					    arrNew = arrNew.replace(/0/g,'')
						arr = ['SETPRM','MODE','W','1',arrNew, dur3]
						break;
				}
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
				
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsA5CSetWorkMode.vue?0cb55c1b